const Tag = {
  hidden: 'hidden',
  medpoint: 'medpoint',
}

export { Tag }
